// import { Auth } from "aws-sdk"
import { Auth, Storage } from "aws-amplify";

export async function getAuthUser() {
    // await Auth.currentAuthenticatedUser();
    try {
    const user = await Auth.currentAuthenticatedUser({
        bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    return user;
    } catch(err) {
        console.log(err);
    } 
};

export async function signIn(username, password) {
    try {
        const user = await Auth.signIn(username, password);
        console.log(user.username);
        //setUser(user);
        return user;
    } catch (error) {
        console.log('error signing in', error);
        throw error;
    }
}

export async function signOut () {
    try {
        await Auth.signOut();
    } catch (error) {
        console.log('erro de logout: ', error);
    }
}

export async function readShapefiles (fileKey) {
    const signedURL = await Storage.get(fileKey, {
    level: "private",
    download: true
    });
    // console.log("signedURL ", signedURL);
    return signedURL;
}

export async function downloadFile (fileKey, filename) {
    // get the signed URL string
    const signedURL = await Storage.get(fileKey, {
    level: "private",
    download: true
    });
    // console.log("signedURL ", signedURL);
    downloadBlob(signedURL.Body, filename)
}

export async function uploadFile (fileName, file) {
    return await Storage.put(fileName, file, {
        level: "private",
    });
}

export async function uploadFileWithProgress(key, file, onProgress) {
  return Storage.put(key, file, {
    level: "private",
    // contentType: file.type || "application/octet-stream",
    progressCallback(progressEvent) {
      // progressEvent.loaded / progressEvent.total
      if (progressEvent.total) {
        const pct = (progressEvent.loaded / progressEvent.total) * 100;
        onProgress(pct);
      }
    }
  });
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener('click', clickHandler);
    }, 150);
  };
  a.addEventListener('click', clickHandler, false);
  a.click();
  return a;  
}